import { render, staticRenderFns } from "./TalkSearchRecord.vue?vue&type=template&id=e23f19f8&scoped=true"
import script from "./TalkSearchRecord.vue?vue&type=script&lang=js"
export * from "./TalkSearchRecord.vue?vue&type=script&lang=js"
import style0 from "./TalkSearchRecord.vue?vue&type=style&index=0&id=e23f19f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f19f8",
  null
  
)

export default component.exports